import router from "../../router";
import axios from "axios";
import { Promise } from "q";
const qs = require("querystring");

const state = {
  status: "",
  token: localStorage.getItem("dt_token") || "",
  utente: "",
  siglaDitta: null,
  ditta: null,
  dipendente: "",
  esterno: null,
  opzioni: {},
};

const mutations = {
  authUser(state, userData) {
    state.token = userData.token;
    state.status = "success";
    state.utente = userData.utente;
    state.siglaDitta = userData.siglaDitta;
    state.ditta = userData.ditta;
    state.esterno = userData.esterno;
  },
  clearAuthData(state) {
    state.token = "";
    state.status = "";
    state.utente = "";
    state.siglaDitta = null;
    state.ditta = null;
    state.dipendente = "";
    state.esterno = null;
    state.opzioni = {};
  },
  setDipendente(state, dipendente) {
    state.dipendente = dipendente;
  },
  setOpzioni(state, opzioni) {
    state.opzioni = opzioni;
  },
};

const actions = {
  async login({ commit, dispatch }, authData) {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      auth: {
        username: authData.utente,
        password: authData.password,
      },
    };
    return new Promise((resolve, reject) => {
      axios
        .post(
          "/autenticazione",
          qs.stringify({
            esterni: true,
          }),
          config
        )
        .then((res) => {
          // eslint-disable-next-line
          dispatch("_authUser", res.data).then(() => {
            resolve();
          });
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          localStorage.removeItem("dt_token");
          commit("clearAuthData");
          dispatch("handleError", error.response.data);
          reject();
        });
    });
  },
  async clearStoreData({ commit }) {
    commit("clearGeneralData");
    commit("clearAuthData");
    commit("clearMov");
    commit("clearMovimentiData");
  },
  async setUserInfo({ dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/utente")
        .then((res) => {
          // eslint-disable-next-line
          dispatch("_authUser", res.data).then(() => {
            resolve();
          });
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          dispatch("handleError", error.response.data);
          reject();
        });
    });
  },
  async _authUser({ commit, dispatch }, data) {
    const token = data.diTechToken.token;
    localStorage.setItem("dt_token", token);
    commit("authUser", {
      token,
      utente: data.name,
      ditta: data.ditta,
      siglaDitta: data.siglaDitta,
      esterno: data.esterno,
    });
    // init environment
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    return dispatch("initEnvironment");
  },
  async initEnvironment({ dispatch }) {
    // eslint-disable-next-line
    console.log("*** INIT ***");
    return new Promise((resolve) => {
      dispatch("fetchDipendente").then(() => {
        dispatch("fetchMovimenti").then(() => {
          router.push("/movimenti");
          //dispatch('incrementOffset')
          //dispatch('fetchMovimenti', rootState.movimenti.offset)
          // eslint-disable-next-line
          console.log("*** DONE WITH INIT ***");
          resolve();
        });
        // fill options, def nota spese, elenco causali, cdl and cdc (no need to be asynchronous)
        dispatch("fetchOpzioni");
        dispatch("fetchDefinizioneNotaSpese");
        dispatch("fetchCausali");
        dispatch("fetchElencoCdl");
        // dispatch('fetchElencoCdc')
      });
    });
  },
  async logout({ dispatch }) {
    axios
      .get("/logout")
      .then((res) => {
        // eslint-disable-next-line
        console.log(res);
        dispatch("clearStoreData");
        localStorage.removeItem("dt_token");
        delete axios.defaults.headers.common["Authorization"];
        router.replace("/login");
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error);
        dispatch("handleError", error.response.data);
      });
  },
  // eslint-disable-next-line
  handleError({ dispatch }, error) {
    dispatch("hideWaitDialog");
    const errorData = {
      message: error.message,
      developerMessage: error.developerMessage,
      code: error.code,
      status: error.status,
    };
    // eslint-disable-next-line
    console.log(errorData);
    router.push({
      name: "error",
      params: {
        message: errorData.message,
        developerMessage: errorData.developerMessage,
        code: errorData.code,
        status: errorData.status,
      },
    });
  },
  async fetchDipendente({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/dipendente")
        .then((res) => {
          // eslint-disable-next-line
          commit("setDipendente", res.data.dipendente);
          resolve();
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          dispatch("handleError", {
            developerMessage:
              "Impossibile recuperare il dipendente per l'utente " +
              state.utente,
          });
          reject();
        });
    });
  },
  async fetchOpzioni({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/variabili/web/3")
        .then((res) => {
          // eslint-disable-next-line
          console.log(res);
          commit("setOpzioni", res.data);
          resolve();
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          dispatch("handleError", {
            developerMessage: "Impossibile recuperare le opzioni ",
          });
          reject();
        });
    });
  },
};

const getters = {
  getToken(state) {
    return state.token;
  },
  getUtente(state) {
    return state.utente ? state.utente.toUpperCase() : state.utente;
  },
  getDipendente(state) {
    return state.dipendente;
  },
  getSiglaDitta(state) {
    return state.siglaDitta;
  },
  getDitta(state) {
    return state.ditta;
  },
  getOpzioni(state) {
    return state.opzioni;
  },
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
